"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppSettingsRejections = void 0;
const button_1 = require("client/components/material/button");
const select_1 = require("client/components/material/select");
const text_field_1 = require("client/components/material/text-field");
const material_ui_icons_1 = require("material-ui-icons");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const React = require("react");
const app_settings_1 = require("shared/app-settings");
const errors_1 = require("shared/erx/errors");
const store_1 = require("../../store");
require("./app-settings-rejections.less");
let AppSettingsRejections = class AppSettingsRejections extends React.Component {
    constructor() {
        super(...arguments);
        this.settings = null;
        this.rejectionList = [];
        this.generateSettings = async () => {
            const settings = await store_1.appSettingsStore.readSettings();
            const cleaned = settings
                .filter((setting) => setting.category === app_settings_1.AppCategory.rejections)
                .sort((a, b) => a.displayName > b.displayName ? 1 : -1)
                .map((e) => e);
            /** Populate selections. */
            if (!this.rejectionList.length) {
                cleaned.forEach((setting) => this.rejectionList.push({
                    id: setting.id,
                    label: setting.displayName,
                    value: `${setting.id}`
                }));
            }
            this.settings = cleaned;
        };
        this.handleUpdateInput = () => (event, value) => {
            if (value.includes(" "))
                return;
            this.rejectionInput = value;
        };
        this.handleSubmit = async () => {
            const code = this.rejectionInput.length === 1
                ? `0${this.rejectionInput}`
                : this.rejectionInput;
            const categoryId = this.rejectionChoice;
            const rejection = { code, categoryId };
            const result = await store_1.appSettingsStore.createRejection(rejection);
            this.rejectionInput = null;
            this.rejectionChoice = null;
            this.generateSettings();
        };
        this.handleDelete = async (code, categoryId) => {
            const rejection = { code, categoryId };
            const result = await store_1.appSettingsStore.deleteRejection(rejection);
            this.generateSettings();
        };
        this.handleUpdateSelect = (value) => {
            this.rejectionChoice = value;
        };
        this.renderAddNewRejection = () => (React.createElement("div", { className: "settings__add--wrapper", style: {
                display: "flex",
                justifyContent: "center",
                alignItems: "center"
            } },
            React.createElement(text_field_1.MaterialTextField, { className: "settings__add--input", label: "Error Number", required: true, placeholder: "A3", value: this.rejectionInput || "", onChange: this.handleUpdateInput() }),
            React.createElement(select_1.MaterialSelect, { className: "settings__add--select", options: [...this.rejectionList], required: true, searchable: true, label: "Rejection Management", onSelect: this.handleUpdateSelect, value: this.rejectionChoice || "" }),
            React.createElement(button_1.MaterialButton, { primary: true, className: "settings__add--button", disabled: !this.rejectionInput || !this.rejectionChoice, onClick: this.handleSubmit }, "Add")));
    }
    async componentDidMount() {
        await this.generateSettings();
    }
    async componentWillUnmount() {
        this.settings = null;
    }
    renderSettings() {
        const settings = this.settings;
        const groups = [];
        const blocks = [];
        settings.forEach((setting, i) => {
            const groupName = setting.category;
            if (!groups.includes(groupName))
                groups.push(groupName);
        });
        groups.forEach((group, i) => {
            blocks.push(React.createElement("div", { className: "settings__block", key: i },
                React.createElement("h3", { className: "settings__block-title", id: group }, group.toUpperCase()),
                React.createElement("div", { className: "settings__block-entries" }, settings
                    .filter((setting) => setting.category === group)
                    .map((setting, i) => {
                    const name = setting.displayName;
                    const desc = setting.description;
                    const codes = setting.value.split(",");
                    return (React.createElement("div", { key: i },
                        React.createElement("div", { className: "settings__block-entry" },
                            React.createElement("div", { className: "settings__block-entry--title" }, name),
                            React.createElement("div", { className: "settings__block-entry--body" },
                                React.createElement("span", { className: "settings__block-entry--body-desc" }, desc))),
                        React.createElement("ul", { className: "settings__rejection" }, codes.map((code, i) => {
                            const errNo = code.length === 1 ? `0${code}` : code;
                            const errDesc = errors_1.NCPDP_ERROR_CODE_MAP[errNo];
                            const unknown = () => !errDesc && (React.createElement("span", { style: { color: "lightgray" } },
                                React.createElement("i", null, "Unknown Error")));
                            return (React.createElement("li", { style: { display: "flex", alignItems: "center" }, key: i },
                                React.createElement("span", { style: { minWidth: "fit-content" } },
                                    React.createElement("b", null, errNo),
                                    " - ",
                                    errDesc || unknown()),
                                React.createElement("div", { style: {
                                        width: "100%",
                                        borderBottom: "1px dotted whitesmoke"
                                    } }),
                                React.createElement(material_ui_icons_1.Clear, { className: "settings__rejection--clear", onClick: () => this.handleDelete(code, setting.id), color: "error" })));
                        }))));
                }))));
        });
        const wrapper = (React.createElement("div", { className: "settings__wrapper" },
            React.createElement("div", { className: "settings__add" }, this.renderAddNewRejection()),
            React.createElement("div", { className: "settings__block" }, blocks.map((e) => e))));
        return wrapper;
    }
    render() {
        const didLoad = !!this.settings;
        return (React.createElement("div", null, didLoad ? this.renderSettings() : React.createElement("p", null, "Component is loading.")));
    }
};
__decorate([
    mobx_1.observable
], AppSettingsRejections.prototype, "settings", void 0);
__decorate([
    mobx_1.observable
], AppSettingsRejections.prototype, "rejectionList", void 0);
__decorate([
    mobx_1.observable
], AppSettingsRejections.prototype, "rejectionChoice", void 0);
__decorate([
    mobx_1.observable
], AppSettingsRejections.prototype, "rejectionInput", void 0);
AppSettingsRejections = __decorate([
    mobx_react_1.observer
], AppSettingsRejections);
exports.AppSettingsRejections = AppSettingsRejections;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/app-settings/tabs/app-settings-rejections/app-settings-rejections.tsx
// module id = 3200
// module chunks = 0